<template>
  <action-modal :is-open="true" @close="close">
    <span slot="title">{{ title }}</span>
    <v-layout wrap mt-4>
      <v-flex xs12 sm4 md4 lg2>
        <v-subheader>Role name*</v-subheader>
      </v-flex>
      <v-flex xs10 md8 lg6>
        <v-text-field
          v-model="role.name"
          outlined
          dense
          placeholder="Enter role name"
        />
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 sm4 md4 lg2>
        <v-subheader>Role description*</v-subheader>
      </v-flex>
      <v-flex xs10 md8 lg6>
        <v-text-field
          v-model="role.description"
          outlined
          dense
          placeholder="Enter role description"
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 mt-2>
        <v-card-title>Select Permissions:</v-card-title>
        <!-- TODO - move permissions to its own thing instead of binding to prop -->
        <div class="permissions-container">
          <permissions-container :permissions="selectedPermissions" />
        </div>
        <!--
        <div v-for="(permission, index) in selectedPermissions" :key="index">
          <v-checkbox
            class="ml-6 mt-0"
            v-model="selectedPermissions[index].selected"
            :label="`${permission.name} - ${permission.description}`"
          />
        </div>
        -->
      </v-flex>
    </v-layout>
    <div slot="actions">
      <v-layout>
        <v-btn :disabled="!validRole" color="primary" @click="saveNewRole"
          >Save New Role</v-btn
        >
      </v-layout>
    </div>
  </action-modal>
</template>

<script>
import ActionModal from "./ActionModal";
import PermissionsContainer from "@/components/shared/PermissionsContainer";

export default {
  name: "AddRoleModal",
  props: {
    permissions: {
      type: Array,
      default: () => {
        return [];
      },
    },
    title: {
      type: String,
      default: "",
    },
  },
  components: {
    ActionModal,
    PermissionsContainer,
  },
  mounted() {
    this.initializeSelectedPermissions();
  },
  data: function() {
    return {
      role: {
        name: "",
        roleType: "associate",
        description: "",
        permissions: [],
      },
      selectedPermissions: [],
    };
  },
  watch: {
    selectedPermissions: {
      handler(vals) {
        this.role.permissions = vals;
      },
      deep: true,
    },
  },
  computed: {
    validRole() {
      const { role } = this;
      return (
        role.name.length &&
        role.description.length &&
        role.permissions.some((perm) => perm.selected)
      );
    },
  },
  methods: {
    saveNewRole() {
      const { role } = this;
      role.permissions = role.permissions
        .filter((perm) => perm.selected)
        .map((perm) => perm._id);
      this.$emit("save", role);
    },
    close() {
      this.$emit("update:addRoleModal", false);
    },
    initializeSelectedPermissions() {
      const { permissions } = this;
      const copied = JSON.parse(JSON.stringify(permissions));
      this.selectedPermissions = copied.map((perm) => {
        perm.selected = false;
        return perm;
      });
    },
  },
};
</script>
